<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/userBalance/filBalance/summary/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      prop="type"
      label="类型">
      <template slot-scope="scope">
        <span>{{scope.row.type==0?'客户+销售':scope.row.type==1?'公司':'总资产'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="available"
      label="可用FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.available),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="pledge"
      label="质押FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.pledge),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="frozen"
      label="待释放FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.frozen),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="total"
      label="合计FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.total),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="repertoryPower"
      label="库存算力数量T">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.repertoryPower),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="repertoryPrice"
      label="库存算力售价FIL">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.repertoryPrice),4)}}</span>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.filSummary({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
